export default "__VITE_ASSET__BNJ$h_zI__"